/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ParkingTypeEnum = {
    Default: 'Default',
    Exemption: 'Exemption',
    AssignedZoneParkers: 'AssignedZoneParkers',
    PoolParking: 'PoolParking',
    Easypass: 'Easypass',
    ShortTerm: 'ShortTerm',
    LongTerm: 'LongTerm'
} as const;
export type ParkingTypeEnum = typeof ParkingTypeEnum[keyof typeof ParkingTypeEnum];

